/* ------------------------------------------------------------------
   Mobile product gallery dots.

   The mobile gallery is a native scroll-snap slider (no JS index
   tracking), so we build a dots indicator from the slides, mark the
   active one via IntersectionObserver on scroll, and scroll to the
   matching slide when a dot is tapped. Mobile-only; on desktop the CSS
   hides the dots and the gallery uses its stacked/thumbnail layout.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var SLIDER_SELECTOR = '.product__images--mobile-slider';
  var LIST_SELECTOR = '[data-product-media-list]';
  var SLIDE_SELECTOR = '.product__slide';

  function buildDots(slider) {
    if (slider.dataset.diaDotsBound) return;
    var list = slider.querySelector(LIST_SELECTOR);
    if (!list) return;
    var slides = Array.prototype.slice.call(
      list.querySelectorAll(SLIDE_SELECTOR)
    );
    if (slides.length < 2) return; // a single image needs no dots

    slider.dataset.diaDotsBound = '1';

    var dotsWrap = document.createElement('ul');
    dotsWrap.className = 'dia-gallery-dots';
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Product image');

    var dots = slides.map(function (slide, i) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dia-gallery-dots__dot';
      btn.setAttribute('aria-label', 'Go to image ' + (i + 1));
      if (i === 0) btn.setAttribute('aria-current', 'true');
      btn.addEventListener('click', function () {
        // Center the target slide; scroll-snap settles it.
        list.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
      li.appendChild(btn);
      dotsWrap.appendChild(li);
      return btn;
    });

    // Place dots right after the slider's media list.
    list.insertAdjacentElement('afterend', dotsWrap);

    function setActive(index) {
      dots.forEach(function (dot, i) {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    // Track the most-visible slide as the active one.
    var observer = new IntersectionObserver(
      function (entries) {
        var best = null;
        entries.forEach(function (entry) {
          if (!best || entry.intersectionRatio > best.intersectionRatio) {
            best = entry;
          }
        });
        if (best && best.isIntersecting) {
          var idx = slides.indexOf(best.target);
          if (idx > -1) setActive(idx);
        }
      },
      { root: list, threshold: [0.5, 0.75, 1] }
    );
    slides.forEach(function (slide) {
      observer.observe(slide);
    });
  }

  function init() {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;
    document.querySelectorAll(SLIDER_SELECTOR).forEach(buildDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ------------------------------------------------------------------
     Move the product breadcrumb onto the gallery as a full-width strip
     across the top of the image. The breadcrumb lives in the right-hand
     content column by default; relocate it into the gallery container so
     CSS can overlay it. Absolutely positioned, so no layout shift.
     ------------------------------------------------------------------ */
  function overlayBreadcrumb() {
    var gallery = document.querySelector(
      'product-images.product__images, .product__images'
    );
    if (!gallery) return;
    var crumb = document.querySelector('.product__breadcrumbs');
    if (!crumb) return;
    if (gallery.querySelector('.product__breadcrumbs')) return; // already moved
    crumb.classList.add('product__breadcrumbs--on-image');
    gallery.classList.add('product__images--has-breadcrumb');
    gallery.insertBefore(crumb, gallery.firstChild);
  }

  function initAll() {
    overlayBreadcrumb();
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', overlayBreadcrumb);
  } else {
    overlayBreadcrumb();
  }

  // Product swaps re-render the gallery; rebuild dots + re-place breadcrumb.
  document.addEventListener('theme:product-info:loaded', function () {
    initAll();
  });
})();
